module.exports = __webpack_public_path__ + "img/Quiliity-FE_Affordable Premiums Icon.43baa571.svg";